import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-home-02',
  standalone: true,
  templateUrl: '../../assets/home-02.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamHome02Icon {}
